import React, { useEffect, useState } from "react";
import { baseUrl } from "../../config.js";
import useToken from "../../useToken.js";
import './Stock.css';

const MisProductos = () => {
    const { token } = useToken();
    const [productos, setProductos] = useState([]);
    const [uoms, setUoms] = useState([]);
    const [nuevo, setNuevo] = useState({ name: '', uomId: '' });
    const [creando, setCreando] = useState(false);
    const [msgProducto, setMsgProducto] = useState('');

    useEffect(() => {
        if (token) {
            cargarProductos();
        }
    }, [token]);

    const cargarProductos = async () => {
        try {
            const [prods, unidades] = await Promise.all([
                fetch(baseUrl + "my/products", { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()),
                fetch(baseUrl + "my/uoms", { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()),
            ]);
            setProductos(prods?.data || []);
            setUoms(unidades?.data || []);
        } catch (e) {
            console.error(e);
        }
    };

    const crearProducto = async () => {
        if (!nuevo.name.trim()) {
            setMsgProducto('Ingresa el nombre del producto');
            return;
        }
        setCreando(true);
        setMsgProducto('');
        try {
            const res = await fetch(baseUrl + "my/products", {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ name: nuevo.name.trim(), uomId: nuevo.uomId * 1 || 0 }),
            }).then(r => r.json());
            if (!res?.success) throw new Error(res?.error || 'No se pudo crear el producto');
            setMsgProducto(res.data?.existed ? 'Ya tenías un producto con ese nombre' : 'Producto creado ✓');
            setNuevo({ name: '', uomId: '' });
            cargarProductos();
        } catch (e) {
            setMsgProducto(e.message || 'No se pudo crear el producto');
        } finally {
            setCreando(false);
        }
    };

    return (
        <div className="stock">
            <div className="stockHeader">
                <h2>Mis productos</h2>
            </div>
            
            <div className="stockProductos">
                <p className="stockProductosNota">
                    Crea tus productos con su unidad de medida para indicar qué entra y sale
                    en tus In/Out. Se registran en el inventario del almacén a tu nombre.
                </p>
                {productos.length > 0 && (
                    <ul className="listaProductos">
                        {productos.map(p => (
                            <li key={p.id}>
                                <b>{p.name}</b>
                                <span>{p.uom || 'Sin unidad'}</span>
                                <i>{p.code}</i>
                            </li>
                        ))}
                    </ul>
                )}
                <div className="nuevoProducto">
                    <input type="text" placeholder="Nombre del producto (ej. Caja zapatos)"
                        value={nuevo.name}
                        onChange={(e) => setNuevo({ ...nuevo, name: e.target.value })} />
                    <select value={nuevo.uomId} onChange={(e) => setNuevo({ ...nuevo, uomId: e.target.value })}>
                        <option value="">Unidad de medida</option>
                        {uoms.map(u => (
                            <option key={u.id} value={u.id}>{u.name}</option>
                        ))}
                    </select>
                    <button className="btn" disabled={creando} onClick={crearProducto}>
                        {creando ? 'Creando…' : 'Crear producto'}
                    </button>
                </div>
                {msgProducto && <div className="stockMsg">{msgProducto}</div>}
            </div>
        </div>
    );
};

export default MisProductos;
